import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS, SUBMISSION_KEYS } from './queryKeys';

export function useDeleteSubmission(formId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (submissionId: string) => formsService.deleteSubmission(formId, submissionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SUBMISSION_KEYS.byForm(orgId ?? '', formId) });
      queryClient.invalidateQueries({ queryKey: FORM_KEYS.analytics(orgId ?? '', formId) });
    },
  });
}
